import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Label, TreeNavDivider } from "@animech/ui";
import * as Styled from "./custom-drawer.style";
import { selectors, useAppSelector } from "store";
import { ParameterInputGroup, ParameterInput, } from "ui/components/elements/parameter-input";
import { isGroup } from "store/system-data/helpers";
/**
 * The inputs of one or more Tacton parameter groups, with sub-groups laid out
 * together and dividers between entries.
 *
 * Extracted from the sidebar drawer so the same parameters can be offered
 * somewhere else without a second copy of this rendering — the cardboard box
 * panel in the 3D scene shows the object group this way.
 */
export var ParameterList = function (_a) {
    var groupIds = _a.groupIds;
    var parametersAndGroups = useAppSelector(selectors.selectParametersGroupedInSubGroups(groupIds));
    return (_jsx(_Fragment, { children: parametersAndGroups.map(function (parameterOrGroup, index) {
            var showDivider = index !== parametersAndGroups.length - 1;
            /* Each parameter and its divider share a wrapper on purpose: the
             * divider is then its wrapper's last child, and `TreeNavDivider`
             * hides itself as a last child, so only the group dividers (which
             * override that) draw a line. Without the wrapper every divider
             * would. */
            return (_jsxs("div", { children: [_jsx("div", { className: "parameter-input-container", children: isGroup(parameterOrGroup) ? (_jsxs(Styled.ParameterGroup, { numberOfParametersInGroup: parameterOrGroup.parameters.length, children: [parameterOrGroup.description ? (_jsx(Label, { children: parameterOrGroup.description })) : null, _jsx(ParameterInputGroup, { properties: parameterOrGroup.properties, children: parameterOrGroup.parameters.map(function (param) { return (_jsx(ParameterInput, { parameter: param }, param.id)); }) })] })) : (_jsx(ParameterInput, { parameter: parameterOrGroup })) }), showDivider &&
                        (isGroup(parameterOrGroup) ? (_jsx(Styled.GroupTreeNavDivider, {})) : (_jsx(TreeNavDivider, {})))] }, parameterOrGroup.id));
        }) }));
};
